import { Moon, Sun } from "lucide-react";
import { useTheme } from "../theme/ThemeContext";

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === "dark" ? "claro" : "oscuro";
  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button className={`theme-toggle${compact ? " theme-toggle--compact" : ""}`} type="button" onClick={toggleTheme} aria-label={`Cambiar a tema ${nextTheme}`} title={`Cambiar a tema ${nextTheme}`}>
      <Icon size={compact ? 19 : 18} aria-hidden="true" />
      {compact ? null : <span>Tema {theme === "dark" ? "oscuro" : "claro"}</span>}
    </button>
  );
}
